module.exports = __webpack_public_path__ + "static/media/DONT_SHOOT_FILMS.10153931.png";